module.exports = __webpack_public_path__ + "static/img/preview-yellow-with-progress-bar.436a9ae4.png";